/* eslint-disable @typescript-eslint/no-var-requires */

export const ActiveOrderFallbackIllus = [
  require('./active-order-hero-card-fallback.png'),
  require('./active-order-hero-card-fallback@2x.png'),
];
export const NoActiveOrderFallbackIllus = require('./no-active-order-hero-card-fallback@2x.png');
